import React from 'react';

export type StatusBadgeTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger';

interface StatusBadgeProps {
  tone?: StatusBadgeTone;
  children: React.ReactNode;
  className?: string;
}

/**
 * Pill-shaped status indicator with a colored dot.
 * Used in place of `rsuite/Tag` for status columns — gives a stronger
 * semantic + visual signal at the same density.
 */
export default function StatusBadge({
  tone = 'neutral',
  children,
  className,
}: StatusBadgeProps) {
  const cls = `status-badge status-badge--${tone}${className ? ` ${className}` : ''}`;
  return <span className={cls}>{children}</span>;
}
